define("ROOM4.CCAProductGallery.CCAProductGallery.List.View", [
  "PageType.Base.View",
  "room4_ccaproductgallery_ccaproductgallery.tpl",
  "ROOM4.CCAProductGallery.CCAProductGallery.Model",
  "ROOM4.CCAProductGallery.CCAProductGallery.Collection",
  "ROOM4.CCAProductGallery.CCAProductGallery.DescriptionHelper",
  "ROOM4.CCAProductGallery.CCAProductGallery.SchemaHelper",
  "ROOM4.CCAProductGallery.CCAProductGallery.VehicleFilter.Model",
  "ROOM4.CCAProductGallery.CCAProductGallery.SchemaPublisher.View",
  "ROOM4.CCAProductGallery.CCAProductGalleryHeader.View",
  "Facets.FacetedNavigation.View",
  "Facets.FacetsDisplay.View",
  "Facets.Helper",
  "GlobalViews.Pagination.View",
  "jQuery",
  "Backbone",
  "Configuration",
  "Utils",
  "Utilities.ResizeImage",
  "underscore",
  "jQuery.scPush",
], function (
  PageTypeBaseView,
  room4_ccaproductgallery_ccaproductgallery_tpl,
  CCAProductGalleryModel,
  CCAProductGalleryCollection,
  DescriptionHelper,
  SchemaHelper,
  VehicleFilterModel,
  SchemaPublisherView,
  CCAProductGalleryHeaderView,
  FacetsFacetedNavigationView,
  FacetsFacetsDisplayView,
  FacetsHelper,
  GlobalViewsPaginationView,
  jQuery,
  Backbone,
  Configuration,
  Utils,
  resizeImage,
  _
) {
  "use strict";

  var SCHEMA_PUBLISHER_DOM_ID =
    "ccaproductgallery-list-schema-organization";
  var GALLERY_FACETS = [
    {
      id: "custitemrs_brand",
      url: "Brand",
      name: "Brand",
      priority: "15",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_model",
      url: "Model",
      name: "Model",
      priority: "14",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_attributes",
      url: "Attributes",
      name: "Attributes",
      priority: "13",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitem_sdb_wheel_offset_min_filter",
      url: "custitem_sdb_wheel_offset_min_filter",
      name: "Offset",
      priority: "12",
      behavior: "range",
      template: "facets_faceted_navigation_item_range.tpl",
      collapsed: false,
      isParameter: true,
    },
    {
      id: "custitem_sdb_wheel_width_filter",
      url: "custitem_sdb_wheel_width_filter",
      name: "Wheel Width",
      priority: "11",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_p_wheel_offset_category",
      url: "OffsetCategory",
      name: "Offset Category",
      priority: "10",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_wheel_bolt_patterns",
      url: "BoltPattern",
      name: "Bolt Pattern",
      priority: "9",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_wheel_diameter_min",
      url: "WheelDiameter",
      name: "Wheel Diameter",
      priority: "8",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_wheel_finish_category",
      url: "FinishCategory",
      name: "Wheel Finish Category",
      priority: "7",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitem_sdb_wheel_centerbore_filter",
      url: "custitem_sdb_wheel_centerbore_filter",
      name: "Wheel Center Bore",
      priority: "6",
      behavior: "range",
      template: "facets_faceted_navigation_item_range.tpl",
      collapsed: false,
      isParameter: true,
    },
    {
      id: "custitem_sdb_tire_load_index_filter",
      url: "custitem_sdb_tire_load_index_filter",
      name: "Tire Load Index",
      priority: "5",
      behavior: "range",
      template: "facets_faceted_navigation_item_range.tpl",
      collapsed: false,
      isParameter: true,
    },
    {
      id: "custitemrs_p_tire_height",
      url: "AspectRatio",
      name: "Tire Height",
      priority: "4",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_p_tire_width",
      url: "TireWidth",
      name: "Tire Width",
      priority: "3",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_tire_inside_diameter",
      url: "InsideDiameter",
      name: "Tire Rim Size",
      priority: "2",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custitemrs_tire_service_type",
      url: "ServiceType",
      name: "Tire Service Type",
      priority: "1",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custrecord_ccaw_ge_rubbing",
      url: "Rubbing",
      name: "Rubbing",
      priority: "0",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custrecord_ccaw_ge_trimming_amount",
      url: "Trimming",
      name: "Trimming",
      priority: "-1",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
    {
      id: "custrecord_ccaw_ge_suspension_adjustment",
      url: "SuspensionAdjustment",
      name: "Suspension Adjustment",
      priority: "-2",
      behavior: "multi",
      collapsed: true,
      isParameter: true,
      max: 8,
    },
  ];

  var CARD_HEIGHT_TO_WIDTH_RATIO = 1.16;
  var CARD_HEADER_HEIGHT_PERS = 12.5;
  var CARD_FOOTER_HEIGHT_PERS = 31;

  /**
   * @typedef {Object} Container
   * @property {Function} getComponent
   */

  /**
   * @typedef {Object} GalleryCardImagePosition
   * @property {number} [widthPers] - Horizontal width for the image, percentage value where 100 means no scaling, used by default
   * @property {number} [posXPers] - Horizontal position of the image, percentage
   * @property {number} [posYPers] - Vertical position of the image, percentage
   */

  /**
   * Calculates image position depending on the vehicle bounding box.
   * Image positioned absolute within the card with overflow hidden.
   * Top part of the card is header, bottom part is footer, they have fixed height in percentage of the card height.
   * Header and footer overlap the image, so they create vertical limits for the image position.
   * Image has an area of interest - vehicle bounding box with some padding, that should be visible and as much centered as possible.
   * Image width style expected >= 100%, image height style auto
   * Limitations:
   * - Image top never goes below the header
   * - Image bottom never goes over the footer
   * - If both limits impossible to achieve then scale image until image height reaches
   *   the viewport height and adjust horizontal position
   * @param {number} imWidth original image width, px
   * @param {number} imHeight original image height, px
   * @param {number} objWidth vehicle bounding box width, px
   * @param {number} objHeight vehicle bounding box height, px
   * @param {number} objX vehicle bounding box X coordinate, px
   * @param {number} objY vehicle bounding box Y coordinate, px
   * @param {number} cardHeightToWidthRatio card height to width ratio
   * @param {number} headerHeightPers header height in percentage of the card height
   * @param {number} footerHeightPers footer height in percentage of the card height
   * @returns {GalleryCardImagePosition}
   */
  function cardImagePosition(
    imWidth,
    imHeight,
    objWidth,
    objHeight,
    objX,
    objY,
    cardHeightToWidthRatio,
    headerHeightPers,
    footerHeightPers
  ) {
    var objTopPers = (objY / imHeight) * 100;
    var objBottomPers = ((objY + objHeight) / imHeight) * 100;
    var objCenterYPers = (objTopPers + objBottomPers) / 2;

    var verticalViewCenterPers =
      (100 - headerHeightPers - footerHeightPers) / 2 + headerHeightPers;

    // The image height to card height ratio if both scaled to same width
    var imageHeightInCard = imHeight / imWidth / cardHeightToWidthRatio;

    if (imageHeightInCard * 100 >= 100 - headerHeightPers - footerHeightPers) {
      // image taller than viewport
      if (objCenterYPers * imageHeightInCard > verticalViewCenterPers) {
        // moving image up
        var maxPossibleDisplacementPers =
          100 - footerHeightPers - imageHeightInCard * 100;
        return {
          widthPers: 100,
          posXPers: 0,
          posYPers: Math.max(
            maxPossibleDisplacementPers,
            verticalViewCenterPers - objCenterYPers * imageHeightInCard
          ),
        };
      }
      // moving image down
      var maxPossibleDisplacementPers = headerHeightPers;
      return {
        widthPers: 100,
        posXPers: 0,
        posYPers: Math.min(
          maxPossibleDisplacementPers,
          verticalViewCenterPers - objCenterYPers * imageHeightInCard
        ),
      };
    }

    // image shorter than viewport, scaling width to fit height
    var imageWidthInCard =
      (100 - headerHeightPers - footerHeightPers) / imageHeightInCard;
    var widthPers = imageWidthInCard * 100;
    var objCenterXPers = ((objX + objWidth / 2) / imWidth) * 100;

    if (objCenterXPers * imageWidthInCard >= 50) {
      // moving image left
      var maxPossibleDisplacementPers = 100 - widthPers;
      return {
        widthPers: widthPers,
        posXPers: Math.max(
          maxPossibleDisplacementPers,
          50 - objCenterXPers * imageWidthInCard
        ),
        posYPers: headerHeightPers,
      };
    }

    // can't move image right, it on the left side of the card already
    return {
      widthPers: widthPers,
      posXPers: 0,
      posYPers: headerHeightPers,
    };
  }

  function toPositiveInteger(value, defaultValue) {
    var parsed = parseInt(value, 10);

    return !isNaN(parsed) && parsed > 0 ? parsed : defaultValue;
  }

  function toFiniteNumber(value) {
    var parsed = Number(value);

    return isFinite(parsed) ? parsed : null;
  }

  function getValidHeroImageSize(size) {
    var width = toFiniteNumber(size && size.width);
    var height = toFiniteNumber(size && size.height);
    var box = size && size.vehicleBox;
    var x1 = toFiniteNumber(box && box.x1);
    var y1 = toFiniteNumber(box && box.y1);
    var x2 = toFiniteNumber(box && box.x2);
    var y2 = toFiniteNumber(box && box.y2);

    if (
      !width ||
      !height ||
      x1 === null ||
      y1 === null ||
      x2 === null ||
      y2 === null
    ) {
      return null;
    }

    return {
      width: width,
      height: height,
      vehicleBox: {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
      },
    };
  }

  function getCardImageStyle(size) {
    var validSize = getValidHeroImageSize(size);
    var box;
    var position;

    if (!validSize) {
      return "";
    }

    box = validSize.vehicleBox;
    position = cardImagePosition(
      validSize.width,
      validSize.height,
      box.x2 - box.x1,
      box.y2 - box.y1,
      box.x1,
      box.y1,
      CARD_HEIGHT_TO_WIDTH_RATIO,
      CARD_HEADER_HEIGHT_PERS,
      CARD_FOOTER_HEIGHT_PERS
    );

    return (
      "width:" +
      position.widthPers +
      "%;left:" +
      position.posXPers +
      "%;top:" +
      position.posYPers +
      "%;"
    );
  }

  function getCurrentFragment() {
    var fragment = (Backbone.history && Backbone.history.fragment) || "gallery";
    var search = window.location.search || "";

    return fragment.indexOf("?") === -1 && search
      ? fragment + search
      : fragment;
  }

  function getLegacyInvoiceId(fragment) {
    var path = String(fragment || "").split("?")[0].replace(/^\/+|\/+$/g, "");
    var pathParts = path.split("/");
    var segment;
    var matches;

    if (pathParts.length !== 2 || pathParts[0] !== "gallery") {
      return "";
    }

    segment = pathParts[1];

    try {
      segment = decodeURIComponent(segment);
    } catch (error) {
      return "";
    }

    matches = segment.match(/^[A-Za-z0-9-]+-([0-9]{7})$/);

    return matches ? matches[1] : "";
  }

  function getTranslatorConfig(pageSize) {
    return {
      fallbackUrl: "gallery",
      defaultShow: pageSize,
      defaultOrder: null,
      defaultDisplay: null,
      facets: GALLERY_FACETS.concat(VehicleFilterModel.getFacetDefinitions()),
      facetsAsUrlParameters: true,
      facetDelimiters: Configuration.get("facetDelimiters"),
      facetsSeoLimits: {},
    };
  }

  function isRangeFacetConfig(facetConfig) {
    return facetConfig && facetConfig.behavior === "range";
  }

  function isBlankRangeValue(value) {
    value = value === null || value === undefined ? "" : String(value);

    return !value || value === "undefined";
  }

  function getRangeDelimiter(translator) {
    return (
      (translator &&
        translator.configuration &&
        translator.configuration.facetDelimiters &&
        translator.configuration.facetDelimiters.betweenRangeFacetsValues) ||
      "to"
    );
  }

  function parseRangeValue(value, translator) {
    var delimiter = getRangeDelimiter(translator);
    var tokens;

    if (!value) {
      return null;
    }

    if (typeof value === "object" && !_.isArray(value)) {
      return !isBlankRangeValue(value.from) && !isBlankRangeValue(value.to)
        ? {
            from: value.from,
            to: value.to,
          }
        : null;
    }

    value = String(value);
    tokens = value.split(delimiter);

    return tokens.length === 2 &&
      !isBlankRangeValue(tokens[0]) &&
      !isBlankRangeValue(tokens[1])
      ? {
          from: tokens[0],
          to: tokens[1],
        }
      : null;
  }

  function decodeOptionValue(value) {
    value = value === null || value === undefined ? "" : String(value);

    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  function getCurrentFragmentOptions() {
    var fragment = getCurrentFragment();
    var queryIndex = fragment.indexOf("?");
    var options = {};

    if (queryIndex === -1) {
      return options;
    }

    _.each(fragment.substring(queryIndex + 1).split("&"), function (pair) {
      var parts = pair.split("=");
      var name = parts.shift();

      if (name) {
        options[name] = decodeOptionValue(parts.join("="));
      }
    });

    return options;
  }

  function getFragmentRangeValue(facet, translator) {
    var options = getCurrentFragmentOptions();
    var facetConfig = facet.config || {};
    var optionNames = _.uniq([
      facet.id,
      facet.url,
      facetConfig.id,
      facetConfig.url,
    ]);
    var rangeValue = null;

    _.find(optionNames, function (optionName) {
      if (optionName && options[optionName]) {
        rangeValue = parseRangeValue(options[optionName], translator);
      }

      return !!rangeValue;
    });

    return rangeValue;
  }

  function normalizeRangeFacetValue(facet, translator) {
    var rangeValue = parseRangeValue(facet.value, translator);

    if (!rangeValue) {
      rangeValue = getFragmentRangeValue(facet, translator);
    }

    return rangeValue;
  }

  function normalizeTranslatorRangeFacets(translator) {
    _.each(translator && translator.facets, function (facet) {
      var rangeValue;

      if (!isRangeFacetConfig(facet.config)) {
        return;
      }

      rangeValue = normalizeRangeFacetValue(facet, translator);

      if (!rangeValue) {
        throw new Error("Invalid range facet value for " + facet.id);
      }

      facet.value = rangeValue;
    });
  }

  function ensureGalleryFacetTranslatorSupport(translator) {
    var facetNames;

    if (!translator) {
      return translator;
    }

    facetNames = _.uniq(
      _.reduce(
        GALLERY_FACETS,
        function (memo, facetConfig) {
          memo.push(facetConfig.id);

          if (facetConfig.url) {
            memo.push(facetConfig.url);
          }

          return memo;
        },
        []
      )
    );

    translator.facetsToInclude = _.union(
      translator.facetsToInclude || [],
      facetNames
    );

    return translator;
  }

  function getFacetOptionValue(options, facetConfig) {
    return (
      options[facetConfig.id] ||
      (facetConfig.url ? options[facetConfig.url] : "") ||
      ""
    );
  }

  function normalizeFacetOptionValue(value) {
    return _.uniq(String(value || "").split(",")).join(",");
  }

  function encodeGalleryFacetUrlValue(value, translator) {
    return translator.encodeComponent
      ? translator.encodeComponent(value)
      : encodeURIComponent(value);
  }

  function applyGalleryFacetFragmentToTranslator(translator, fragment) {
    var options;

    ensureGalleryFacetTranslatorSupport(translator);

    if (!translator || !fragment || fragment.indexOf("?") === -1) {
      return translator;
    }

    options = getCurrentFragmentOptions();

    _.each(GALLERY_FACETS, function (facetConfig) {
      var selectedValue = getFacetOptionValue(options, facetConfig);

      if (selectedValue && !translator.getFacetValue(facetConfig.id)) {
        translator.parseFacet(
          facetConfig.id,
          normalizeFacetOptionValue(selectedValue)
        );
      }
    });

    return translator;
  }

  function getGalleryFacetConfigById(facetId) {
    return _.find(GALLERY_FACETS, function (facetConfig) {
      return facetConfig.id === facetId;
    });
  }

  function getGalleryFacetParameterNames() {
    return _.uniq(
      _.reduce(
        GALLERY_FACETS,
        function (memo, facetConfig) {
          memo.push(facetConfig.id);

          if (facetConfig.url) {
            memo.push(facetConfig.url);
          }

          return memo;
        },
        []
      )
    );
  }

  function removeGalleryFacetParameters(url) {
    var parts = String(url || "").split("?");
    var baseUrl = parts[0];
    var query = parts.slice(1).join("?");
    var galleryFacetParameterNames = getGalleryFacetParameterNames();
    var remainingParameters;

    if (!query) {
      return url;
    }

    remainingParameters = _.filter(query.split("&"), function (parameter) {
      var parameterName = parameter.split("=")[0];

      return !_.contains(galleryFacetParameterNames, parameterName);
    });

    return remainingParameters.length
      ? baseUrl + "?" + remainingParameters.join("&")
      : baseUrl;
  }

  function appendGalleryFacetParameters(url, translator) {
    var parameters = [];

    _.each(translator.getAllFacets(), function (facet) {
      var facetConfig = getGalleryFacetConfigById(facet.id);
      var parameterName;
      var rangeValue;
      var values;

      if (!facetConfig) {
        return;
      }

      parameterName = facetConfig.url || facetConfig.id;

      if (facetConfig.behavior === "range") {
        rangeValue = normalizeRangeFacetValue(facet, translator);

        if (!rangeValue) {
          throw new Error("Invalid range facet value for " + facet.id);
        }

        parameters.push(
          parameterName +
            "=" +
            encodeGalleryFacetUrlValue(
              String(rangeValue.from) +
                getRangeDelimiter(translator) +
                String(rangeValue.to),
              translator
            )
        );
        return;
      }

      values = _.isArray(facet.value) ? facet.value : [facet.value];
      values = _.filter(values, function (value) {
        return value !== null && value !== undefined && String(value);
      });
      values = _.uniq(values);

      if (values.length) {
        parameters.push(
          parameterName +
            "=" +
            _.map(values, function (value) {
              return encodeGalleryFacetUrlValue(value, translator);
            }).join(",")
        );
      }
    });

    if (!parameters.length) {
      return url;
    }

    return url + (url.indexOf("?") === -1 ? "?" : "&") + parameters.join("&");
  }

  function normalizeGalleryFacetUrl(url, translator) {
    return appendGalleryFacetParameters(
      removeGalleryFacetParameters(url),
      translator
    );
  }

  function normalizeGalleryTextSearchUrl(url, translator) {
    var parts = String(url || "").split("?");
    var baseUrl = parts[0];
    var query = parts.slice(1).join("?");
    var textQuery = String(translator.getOptionValue("keywords") || "").trim();
    var remainingParameters = _.filter(query.split("&"), function (parameter) {
      var parameterName = parameter.split("=")[0];

      return parameterName && parameterName !== "q" && parameterName !== "keywords";
    });

    if (textQuery) {
      remainingParameters.push("q=" + encodeURIComponent(textQuery));
    }

    return remainingParameters.length
      ? baseUrl + "?" + remainingParameters.join("&")
      : baseUrl;
  }

  function enhanceTranslator(translator, vehicleFilterModel) {
    var cloneMethods = [
      "cloneForFacetId",
      "cloneWithoutFacetId",
      "cloneWithoutFacets",
      "cloneForOption",
      "cloneForOptions",
      "cloneWithoutOption",
      "resetAll",
    ];

    if (!translator || translator._galleryFacetAliasDecorated) {
      return translator;
    }

    ensureGalleryFacetTranslatorSupport(translator);

    translator._galleryFacetAliasDecorated = true;
    translator._galleryOriginalGetUrl = translator.getUrl;

    translator.getUrl = function () {
      var originalFacetUrls = _.map(this.facets || [], function (facet) {
        return facet.url;
      });
      var url;

      normalizeTranslatorRangeFacets(this);

      _.each(
        this.facets || [],
        function (facet) {
          var facetConfig = this.getFacetConfig(facet.id);

          facet.url = facetConfig.url || facet.id;
        },
        this
      );

      url = this._galleryOriginalGetUrl.apply(this, arguments);

      _.each(this.facets || [], function (facet, index) {
        facet.url = originalFacetUrls[index];
      });

      url = normalizeGalleryFacetUrl(url, this);
      url = vehicleFilterModel
        ? vehicleFilterModel.getSeoUrl(
            url,
            vehicleFilterModel.getSelectedFilters(this),
            this
          )
        : url;
      return normalizeGalleryTextSearchUrl(url, this);
    };

    _.each(cloneMethods, function (methodName) {
      var originalMethod = translator[methodName];

      if (!_.isFunction(originalMethod)) {
        return;
      }

      translator[methodName] = function () {
        return enhanceTranslator(
          ensureGalleryFacetTranslatorSupport(
            originalMethod.apply(this, arguments)
          ),
          vehicleFilterModel
        );
      };
    });

    return ensureGalleryFacetTranslatorSupport(translator);
  }

  function buildRequestData(
    translator,
    currentPage,
    pageSize,
    vehicleFilterModel,
    textSearchEnabled
  ) {
    var data = {
      page: currentPage,
      pageSize: pageSize,
    };

    _.extend(data, vehicleFilterModel.getRequestData(translator));

    if (textSearchEnabled && translator.getOptionValue("keywords")) {
      data.q = String(translator.getOptionValue("keywords")).trim();
    }

    _.each(translator.getAllFacets(), function (facet) {
      if (vehicleFilterModel.isVehicleFacet(facet.id)) {
        return;
      }

      if (facet.config.behavior === "range") {
        var rangeValue = normalizeRangeFacetValue(facet, translator);

        if (!rangeValue) {
          throw new Error("Invalid range facet value for " + facet.id);
        }

        facet.value = rangeValue;
        data[facet.id + ".from"] = rangeValue.from;
        data[facet.id + ".to"] = rangeValue.to;
      } else if (facet.config.behavior === "multi") {
        data[facet.id] = facet.value.join(",");
      } else {
        data[facet.id] = facet.value;
      }
    });

    return data;
  }

  function getSelectedVehicleTitle(vehicleFilterModel, translator) {
    return getSelectedVehicleTitleFromFilters(
      vehicleFilterModel.getSelectedFilters(translator)
    );
  }

  function getSelectedVehicleTitleFromFilters(selectedVehicleFilters) {
    return _.compact([
      selectedVehicleFilters.year,
      selectedVehicleFilters.make,
      selectedVehicleFilters.model,
    ]).join(" ");
  }

  function normalizeMetaDescriptionValue(value) {
    return value === null || value === undefined ? "" : String(value).trim();
  }

  function fitGalleryMetaDescription(lead, supportClauses) {
    var clauses = supportClauses.slice(0);
    var text = lead;

    function buildText() {
      return clauses.length ? lead + " ➜ " + clauses.join(" ") : lead;
    }

    text = buildText();

    while (text.length > 160 && clauses.length) {
      clauses.pop();
      text = buildText();
    }

    return text;
  }

  function getGalleryMetaDescription(selectedFilters) {
    var year = normalizeMetaDescriptionValue(selectedFilters.year);
    var make = normalizeMetaDescriptionValue(selectedFilters.make);
    var model = normalizeMetaDescriptionValue(selectedFilters.model);
    var brand = "Canada Custom Autoworks";
    var lead;
    var supportClauses;

    if (year && make && model) {
      lead =
        "Browse custom " +
        year +
        " " +
        make +
        " " +
        model +
        " builds at " +
        brand;
      supportClauses = [
        "Real fitment photos with wheel, tire & suspension specs.",
        "Find your setup today!",
      ];
    } else if (make && model) {
      lead =
        "Explore custom " +
        make +
        " " +
        model +
        " fitment galleries at " +
        brand;
      supportClauses = [
        "See real wheel, tire & suspension setups across every year.",
        "Get inspired today!",
      ];
    } else if (year && make) {
      lead = "Browse custom " + year + " " + make + " builds at " + brand;
      supportClauses = [
        "Real fitment photos with wheel, tire & suspension specs.",
        "Find your setup today!",
      ];
    } else if (make) {
      lead = "Discover custom " + make + " builds at " + brand;
      supportClauses = [
        "Real fitment photos with wheel, tire & suspension specs across every model.",
        "Browse the gallery today!",
      ];
    } else if (year) {
      lead = "Browse custom " + year + " truck & car builds at " + brand;
      supportClauses = [
        "Real fitment photos with wheel, tire & suspension specs.",
        "Find your setup today!",
      ];
    } else {
      lead = "【Custom Fitment Gallery】➜ at " + brand;
      supportClauses = [
        "Browse thousands of real builds with wheel, tire & suspension specs.",
        "Filter by year, make & model today!",
      ];
    }

    return fitGalleryMetaDescription(lead, supportClauses);
  }

  function getGalleryOpenGraphTitle(selectedFilters) {
    var year = normalizeMetaDescriptionValue(selectedFilters.year);
    var make = normalizeMetaDescriptionValue(selectedFilters.make);
    var model = normalizeMetaDescriptionValue(selectedFilters.model);

    if (year && make && model) {
      return year + " " + make + " " + model + " Fitment Gallery";
    }

    if (make && model) {
      return make + " " + model + " Fitment Gallery";
    }

    if (year && make) {
      return year + " " + make + " Fitment Gallery";
    }

    if (make) {
      return "Custom " + make + " Builds & Fitment Gallery";
    }

    if (year) {
      return year + " Custom Truck & Car Gallery";
    }

    return "Custom Fitment Gallery";
  }

  function getGalleryOpenGraphImageAlt(selectedFilters) {
    var vehicle = _.compact([
      normalizeMetaDescriptionValue(selectedFilters.year),
      normalizeMetaDescriptionValue(selectedFilters.make),
      normalizeMetaDescriptionValue(selectedFilters.model),
    ]).join(" ");

    return vehicle
      ? vehicle + " custom fitment gallery"
      : "Custom fitment gallery at Canada Custom Autoworks";
  }

  function getAbsoluteGalleryUrl(url) {
    url = String(url || "");

    if (!url) {
      return "";
    }

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    if (url.indexOf("//") === 0) {
      return "https:" + url;
    }

    return (
      "https://" +
      window.location.hostname +
      (url.charAt(0) === "/" ? url : "/" + url)
    );
  }

  function getGalleryPageUrl(translator, page) {
    page = toPositiveInteger(page, 0);

    return translator && page
      ? translator.cloneForOption("page", page).getUrl()
      : "";
  }

  function getAbsoluteGalleryPageUrl(translator, page) {
    return getAbsoluteGalleryUrl(getGalleryPageUrl(translator, page));
  }

  function getCurrentGalleryPage(view) {
    return toPositiveInteger(
      (view.collection && view.collection.currentPage) || view.currentPage,
      1
    );
  }

  function getGalleryCanonicalUrl(
    selectedFilters,
    vehicleFilterModel,
    translator,
    currentPage
  ) {
    var parameters = [];
    var baseUrl = "https://" + window.location.hostname + "/gallery";
    var seoPath = vehicleFilterModel
      ? vehicleFilterModel.getSeoPath(selectedFilters)
      : "gallery";
    var pageUrl;

    currentPage = toPositiveInteger(currentPage, 1);

    if (currentPage > 1 && translator) {
      pageUrl = getAbsoluteGalleryPageUrl(translator, currentPage);

      if (pageUrl) {
        return pageUrl;
      }
    }

    if (seoPath !== "gallery") {
      return (
        "https://" +
        window.location.hostname +
        "/" +
        seoPath
      );
    }

    _.each(
      [
        ["vehicleYear", selectedFilters.year],
        ["vehicleMake", selectedFilters.make],
        ["vehicleModel", selectedFilters.model],
      ],
      function (parameter) {
        var value = normalizeMetaDescriptionValue(parameter[1]);

        if (value) {
          parameters.push(parameter[0] + "=" + encodeURIComponent(value));
        }
      }
    );

    return parameters.length ? baseUrl + "?" + parameters.join("&") : baseUrl;
  }

  function getGalleryBreadcrumbPages(selectedFilters, vehicleFilterModel) {
    var pages = [
      {
        text: Utils.translate("Gallery"),
        href: "/gallery",
      },
    ];
    var make = normalizeMetaDescriptionValue(
      selectedFilters && selectedFilters.make
    );
    var model = normalizeMetaDescriptionValue(
      selectedFilters && selectedFilters.model
    );
    var year = normalizeMetaDescriptionValue(
      selectedFilters && selectedFilters.year
    );
    var makePath;
    var modelPath;
    var yearPath;

    if (!make || (year && !model) || !vehicleFilterModel) {
      return pages;
    }

    makePath = vehicleFilterModel.getSeoPath({
      make: make,
    });

    if (makePath === "gallery") {
      return pages;
    }

    pages.push({
      text: make,
      href: "/" + makePath,
    });

    if (!model) {
      return pages;
    }

    modelPath = vehicleFilterModel.getSeoPath({
      make: make,
      model: model,
    });

    if (modelPath === "gallery") {
      return pages;
    }

    pages.push({
      text: model,
      href: "/" + modelPath,
    });

    if (!year) {
      return pages;
    }

    yearPath = vehicleFilterModel.getSeoPath({
      make: make,
      model: model,
      year: year,
    });

    if (yearPath !== "gallery") {
      pages.push({
        text: year,
        href: "/" + yearPath,
      });
    }

    return pages;
  }

  function getMetaTagHtml(attributes) {
    return jQuery("<meta />", attributes).prop("outerHTML") || "";
  }

  function clearSocialMetaTags() {
    jQuery("head meta[property^='og:'], head meta[name^='twitter:']").remove();
  }

  function getGalleryOpenGraphMetaTags(
    selectedFilters,
    canonicalUrl,
    imageUrl
  ) {
    var title = getGalleryOpenGraphTitle(selectedFilters);
    var description = getGalleryMetaDescription(selectedFilters);
    var imageAlt = getGalleryOpenGraphImageAlt(selectedFilters);

    return [
      getMetaTagHtml({ property: "og:type", content: "website" }),
      getMetaTagHtml({
        property: "og:site_name",
        content: "Canada Custom Autoworks",
      }),
      getMetaTagHtml({ property: "og:locale", content: "en_CA" }),
      getMetaTagHtml({ property: "og:title", content: title }),
      getMetaTagHtml({ property: "og:description", content: description }),
      getMetaTagHtml({ property: "og:url", content: canonicalUrl }),
      getMetaTagHtml({ property: "og:image", content: imageUrl }),
      getMetaTagHtml({
        property: "og:image:secure_url",
        content: imageUrl,
      }),
      getMetaTagHtml({ property: "og:image:type", content: "image/jpeg" }),
      getMetaTagHtml({ property: "og:image:width", content: "1200" }),
      getMetaTagHtml({ property: "og:image:height", content: "630" }),
      getMetaTagHtml({ property: "og:image:alt", content: imageAlt }),
    ].join("");
  }

  function setGalleryPageMeta(view, selectedVehicleFilters) {
    var selectedVehicleTitle = getSelectedVehicleTitleFromFilters(
      selectedVehicleFilters
    );
    var hasTextQuery = !!view.translator.getOptionValue("keywords");
    var canonicalTranslator = hasTextQuery
      ? view.translator.cloneWithoutOption("keywords")
      : view.translator;
    var metaTags;

    view.title = selectedVehicleTitle
      ? Utils.translate("$(0) | Custom Fitment Gallery", selectedVehicleTitle)
      : Utils.translate("Custom Fitment Gallery");
    view.setMetaDescription(getGalleryMetaDescription(selectedVehicleFilters));
    view.canonicalUrl = getGalleryCanonicalUrl(
      selectedVehicleFilters,
      view.vehicleFilterModel,
      canonicalTranslator,
      getCurrentGalleryPage(view)
    );
    clearSocialMetaTags();
    metaTags = getGalleryOpenGraphMetaTags(
      selectedVehicleFilters,
      view.canonicalUrl,
      view.openGraphImageUrl
    );

    if (hasTextQuery) {
      metaTags += getMetaTagHtml({ name: "robots", content: "noindex,follow" });
    }

    view.setMetaTags(metaTags);
  }

  function getGalleryCaseContext(galleryCase, vehicleFilterModel) {
    var slug = galleryCase.get("slug");
    var selectedFilters = {
      year: galleryCase.get("year"),
      make: galleryCase.get("make"),
      model: galleryCase.get("model"),
    };
    var vehicle = galleryCase.get("vehicle");
    var title = galleryCase.get("title");
    var cardCaptionRows = DescriptionHelper.formatGalleryDescription(
      galleryCase.get("description")
    );
    var internalid = galleryCase.get("internalid");
    var cardImageStyle = getCardImageStyle(
      galleryCase.get("hero_image_size")
    );
    var heroImageUrl = galleryCase.get("hero_image_url");
    var heroImageAlt = galleryCase.get("hero_image_alt") || title;
    var detailUrl =
      "/" + vehicleFilterModel.getGalleryItemPath(selectedFilters, slug);
    var absoluteDetailUrl = SchemaHelper.getAbsoluteUrl(detailUrl);
    var imageSchema = heroImageUrl
      ? SchemaHelper.getImageSchemaContext(
          {
            url: heroImageUrl,
            alt: heroImageAlt,
          },
          0,
          absoluteDetailUrl,
          title,
          {
            contentUrl: resizeImage(heroImageUrl, "fullscreen"),
            useIdForUrl: true,
            publicationDate: galleryCase.get("publishdate"),
          }
        )
      : null;
    var imageDescription = imageSchema && imageSchema.name
      ? Utils.translate("View $(0)", imageSchema.name)
      : "";

    return {
      internalid: internalid,
      slug: slug,
      title: title,
      cardCaptionRows: cardCaptionRows,
      hasExpandableCaption: cardCaptionRows.length > 2,
      captionToggleId: "ccaproductgallery-caption-toggle-" + internalid,
      vehicle: vehicle,
      heroImageUrl: heroImageUrl,
      heroImageAlt: heroImageAlt,
      cardImageStyle: cardImageStyle,
      hasCardImageStyle: !!cardImageStyle,
      detailUrl: detailUrl,
      absoluteDetailUrl: absoluteDetailUrl,
      hasSchemaImage: !!imageSchema,
      schemaImageDomId:
        "ccaproductgallery-list-schema-image-" + internalid,
      schemaImageId: imageSchema ? imageSchema.id : "",
      schemaImageUrl: imageSchema ? imageSchema.url : "",
      schemaImageContentUrl: imageSchema ? imageSchema.contentUrl : "",
      schemaImageName: imageSchema ? imageSchema.name : "",
      schemaImageCaption: imageSchema ? imageSchema.caption : "",
      schemaImageDescription: imageDescription,
      schemaImageLicense: imageSchema ? imageSchema.license : "",
      schemaImageAcquireLicensePage: imageSchema
        ? imageSchema.acquireLicensePage
        : "",
      schemaImageCreditText: imageSchema ? imageSchema.creditText : "",
      schemaImageCopyrightNotice: imageSchema
        ? imageSchema.copyrightNotice
        : "",
      schemaImageCreatorName: imageSchema ? imageSchema.creatorName : "",
      hasSchemaImageCopyrightNotice: !!(
        imageSchema && imageSchema.hasCopyrightNotice
      ),
    };
  }

  function getGalleryStructuredData(view, cases) {
    var selectedFilters = view.vehicleFilterModel.getSelectedFilters(
      view.translator
    );
    var canonicalUrl = view.getCanonical();
    var name = getGalleryOpenGraphTitle(selectedFilters);
    var description = getGalleryMetaDescription(selectedFilters);
    var organization = SchemaHelper.getOrganizationSchemaContext();
    var imageObjects = [];
    var collectionPageId = canonicalUrl + "#collection-page";
    var imageGalleryId = canonicalUrl + "#image-gallery";

    _.each(cases || [], function (galleryCase) {
      if (!galleryCase.hasSchemaImage) {
        return;
      }

      var imageObject = {
        "@type": "ImageObject",
        "@id": galleryCase.schemaImageId,
        url: galleryCase.schemaImageUrl,
        contentUrl: galleryCase.schemaImageContentUrl,
        name: galleryCase.schemaImageName,
        caption: galleryCase.schemaImageCaption,
        description: galleryCase.schemaImageDescription,
        mainEntityOfPage: galleryCase.absoluteDetailUrl,
        license: galleryCase.schemaImageLicense,
        acquireLicensePage: galleryCase.schemaImageAcquireLicensePage,
        creditText: galleryCase.schemaImageCreditText,
        creator: {
          "@type": "Organization",
          name: galleryCase.schemaImageCreatorName,
        },
      };

      if (galleryCase.hasSchemaImageCopyrightNotice) {
        imageObject.copyrightNotice =
          galleryCase.schemaImageCopyrightNotice;
      }

      imageObjects.push(imageObject);
    });

    return {
      canonicalUrl: canonicalUrl,
      name: name,
      description: description,
      language: "en-CA",
      organization: organization,
      collectionPageId: collectionPageId,
      imageGalleryId: imageGalleryId,
      imageObjects: imageObjects,
    };
  }

  function getSidebarFacets(collectionFacets) {
    return collectionFacets || [];
  }

  function createFacetedNavigationView(options) {
    var facets = options.facets || [];
    var appliedFacets = options.translator.getAllFacets();
    var hasFacets = !!facets.length;

    return new FacetsFacetedNavigationView({
      categoryItemId: null,
      clearAllFacetsLink: options.translator.cloneWithoutFacets().getUrl(),
      hasCategories: false,
      hasItems: options.hasItems,
      hasFacets: hasFacets,
      hasCategoriesAndFacets: false,
      appliedFacets: appliedFacets,
      hasFacetsOrAppliedFacets: hasFacets || !!appliedFacets.length,
      translator: options.translator,
      facets: facets,
      totalProducts: options.totalProducts,
      keywords: null,
    });
  }

  function getDisplayFacets(translator) {
    return jQuery.extend(true, [], translator.getAllFacets());
  }

  function createMobileFacetActionButtonsView(parentView) {
    return new (Backbone.View.extend({
      template: function () {
        if (Utils.getDeviceType() !== "phone") {
          return "";
        }

        return (
          '<button class="mobile-facet-action-button" id="clear-filters">' +
          Utils.translate("Clear Filters") +
          "</button>" +
          '<button class="mobile-facet-action-button" id="submit-filters">' +
          Utils.translate("Submit") +
          "</button>"
        );
      },

      events: {
        "click #clear-filters": "clearFilters",
        "click #submit-filters": "submitFilters",
      },

      clearFilters: function clearFilters(e) {
        e.preventDefault();

        Backbone.history.navigate(parentView.getClearAllFacetsUrl(), {
          trigger: true,
        });
      },

      submitFilters: function submitFilters(e) {
        e.preventDefault();

        parentView.closeMobileFacetDrawer();
      },
    }))();
  }

  function inspect(obj, maxDepth = 4) {
    const seen = new WeakSet();

    function walk(value, depth) {
      if (value === null) return null;

      // Primitives that JSON can't represent: stringify them
      const type = typeof value;
      if (type === "bigint") return value.toString() + "n";
      if (type === "function")
        return `[Function: ${value.name || "anonymous"}]`;
      if (type === "undefined") return "[undefined]";
      if (type === "symbol") return value.toString();
      if (type !== "object") return value; // string, number, boolean

      // Circular reference check
      if (seen.has(value)) return "[Circular]";

      // Depth limit
      if (depth >= maxDepth)
        return Array.isArray(value) ? "[Array]" : "[Object]";

      seen.add(value);

      let result;
      if (Array.isArray(value)) {
        result = value.map((v) => walk(v, depth + 1));
      } else {
        result = {};
        for (const key of Object.keys(value)) {
          result[key] = walk(value[key], depth + 1);
        }
      }

      seen.delete(value); // allow same object in sibling branches (not circular)
      return result;
    }

    return JSON.stringify(walk(obj, 0), null, 2);
  }

  return PageTypeBaseView.PageTypeBaseView.extend({
    template: room4_ccaproductgallery_ccaproductgallery_tpl,

    attributes: {
      id: "CCAProductGalleryList",
      class: "CCAProductGalleryList",
    },

    initialize: function initialize(options) {
      var configuredPageSize = Configuration.get(
        "CCAProductGallery.gallery.pageSize"
      );
      var configuredOpenGraphImageUrl = Configuration.get(
        "CCAProductGallery.gallery.openGraphImageUrl"
      );

      this.collection = new CCAProductGalleryCollection();
      this.vehicleFilterModel = new VehicleFilterModel();
      this.textSearchEnabled =
        Configuration.get("CCAProductGallery.textSearch.enabled") === true;
      this.legacyInvoiceId = getLegacyInvoiceId(getCurrentFragment());
      this.pageSize = toPositiveInteger(configuredPageSize, 12);
      this.openGraphImageUrl = normalizeMetaDescriptionValue(
        configuredOpenGraphImageUrl
      );
      this.fragment = this.vehicleFilterModel.getFragmentWithSeoVehicleParameters(
        getCurrentFragment(),
        options && options.routerArguments
      );
      this.translatorConfig = getTranslatorConfig(this.pageSize);
      this.translator = enhanceTranslator(
        FacetsHelper.parseUrl(this.fragment, this.translatorConfig, false),
        this.vehicleFilterModel
      );
      applyGalleryFacetFragmentToTranslator(this.translator, this.fragment);
      this.vehicleFilterModel.applyFragmentToTranslator(
        this.translator,
        this.fragment
      );
      if (this.textSearchEnabled && getCurrentFragmentOptions().q) {
        this.translator = this.translator.cloneForOption(
          "keywords",
          getCurrentFragmentOptions().q
        );
      } else if (!this.textSearchEnabled) {
        this.translator = this.translator.cloneWithoutOption("keywords");
      }
      this.currentPage = toPositiveInteger(
        this.translator.getOptionValue("page"),
        1
      );
    },

    beforeShowContent: function beforeShowContent() {
      this.getRelPrev = this.getGalleryRelPrev;
      this.getRelNext = this.getGalleryRelNext;

      this.getBreadcrumbPages = function () {
        return (
          this.breadcrumbPages ||
          getGalleryBreadcrumbPages({}, this.vehicleFilterModel)
        );
      }.bind(this);

      return this.legacyInvoiceId
        ? this.resolveLegacyGalleryUrl()
        : this.fetchGalleryCollection();
    },

    resolveLegacyGalleryUrl: function resolveLegacyGalleryUrl() {
      var self = this;
      var resolverModel = new CCAProductGalleryModel();
      var promise = jQuery.Deferred();

      resolverModel
        .fetch({
          data: {
            action: "resolveLegacyGalleryUrl",
            invoiceId: this.legacyInvoiceId,
          },
        })
        .done(function () {
          var redirectPath;

          if (!resolverModel.get("found")) {
            self
              .fetchGalleryCollection()
              .done(promise.resolve)
              .fail(promise.reject);
            return;
          }

          redirectPath = self.vehicleFilterModel.getGalleryItemPath(
            {
              year: resolverModel.get("year"),
              make: resolverModel.get("make"),
              model: resolverModel.get("model"),
            },
            resolverModel.get("slug")
          );

          if (redirectPath === "gallery") {
            promise.reject(
              new Error("Legacy gallery URL resolved without a canonical path")
            );
            return;
          }

          promise.reject();
          Backbone.history.navigate("/" + redirectPath, {
            trigger: true,
          });
        })
        .fail(promise.reject);

      return promise;
    },

    fetchGalleryCollection: function fetchGalleryCollection() {
      var promise = this.collection.fetch({
        data: buildRequestData(
          this.translator,
          this.currentPage,
          this.pageSize,
          this.vehicleFilterModel,
          this.textSearchEnabled
        ),
      });

      promise.done(
        function () {
          var selectedVehicleFilters;

          this.translator =
            this.vehicleFilterModel.getTranslatorForSelectedFilters(
              this.translator,
              this.collection.resolvedVehicleFilters || {}
            );
          selectedVehicleFilters = this.vehicleFilterModel.getSelectedFilters(
            this.translator
          );
          setGalleryPageMeta(this, selectedVehicleFilters);
          this.breadcrumbPages = getGalleryBreadcrumbPages(
            selectedVehicleFilters,
            this.vehicleFilterModel
          );
          this.translator.setLabelsFromFacets(
            (this.collection.facets || []).concat(
              this.vehicleFilterModel.getFacetLabels(
                this.collection.vehicleOptions || [],
                this.translator
              )
            )
          );
        }.bind(this)
      );

      return promise;
    },

    getCanonical: function getCanonical() {
      var canonicalTranslator = this.translator.getOptionValue("keywords")
        ? this.translator.cloneWithoutOption("keywords")
        : this.translator;

      return (
        this.canonicalUrl ||
        getGalleryCanonicalUrl(
          {},
          this.vehicleFilterModel,
          canonicalTranslator,
          getCurrentGalleryPage(this)
        )
      );
    },

    getGalleryCases: function getGalleryCases() {
      return this.collection.map(function (galleryCase) {
        return getGalleryCaseContext(galleryCase, this.vehicleFilterModel);
      }, this);
    },

    getPageHeading: function getPageHeading() {
      var selectedVehicleTitle = getSelectedVehicleTitle(
        this.vehicleFilterModel,
        this.translator
      );

      return selectedVehicleTitle
        ? Utils.translate("$(0) Gallery", selectedVehicleTitle)
        : Utils.translate("Gallery");
    },

    getJsonLd: function getJsonLd() {
      var schema = getGalleryStructuredData(this, this.getGalleryCases());
      var organizationJsonLd = SchemaHelper.getOrganizationJsonLd();
      var collectionPageJsonLd = {
        "@type": "CollectionPage",
        "@id": schema.collectionPageId,
        url: schema.canonicalUrl,
        name: schema.name,
        description: schema.description,
        inLanguage: schema.language,
        publisher: {
          "@id": schema.organization.id,
        },
        mainEntity: {
          "@id": schema.imageGalleryId,
        },
      };
      var imageGalleryJsonLd = {
        "@type": "ImageGallery",
        "@id": schema.imageGalleryId,
        url: schema.canonicalUrl,
        name: schema.name,
        description: schema.description,
        inLanguage: schema.language,
        publisher: {
          "@id": schema.organization.id,
        },
        image: _.map(schema.imageObjects, function (imageObject) {
          return {
            "@id": imageObject["@id"],
          };
        }),
      };

      return jQuery.Deferred().resolve({
        "@graph": [
          organizationJsonLd,
          collectionPageJsonLd,
          imageGalleryJsonLd,
        ].concat(schema.imageObjects),
      });
    },

    getPaginationUrl: function getPaginationUrl(page) {
      return getGalleryPageUrl(this.translator, page);
    },

    getAbsolutePaginationUrl: function getAbsolutePaginationUrl(page) {
      return getAbsoluteGalleryUrl(this.getPaginationUrl(page));
    },

    getGalleryRelPrev: function getGalleryRelPrev() {
      var currentPage = getCurrentGalleryPage(this);

      return currentPage > 1
        ? this.getAbsolutePaginationUrl(currentPage - 1)
        : "";
    },

    getGalleryRelNext: function getGalleryRelNext() {
      var currentPage = getCurrentGalleryPage(this);
      var totalPages = this.getTotalPages();

      return totalPages && currentPage < totalPages
        ? this.getAbsolutePaginationUrl(currentPage + 1)
        : "";
    },

    showContent: function showContent() {
      var self = this;

      return PageTypeBaseView.PageTypeBaseView.prototype.showContent
        .apply(this, arguments)
        .done(function () {
          var drawer = self.$el.find('[data-action="pushable"]');

          if (jQuery.fn.scPush) {
            drawer.scPush({
              target: "tablet",
            });
          }
        });
    },

    closeMobileFacetDrawer: function closeMobileFacetDrawer() {
      this.$('[data-id="product-search-facets"]').trigger("close");
    },

    getClearAllFacetsUrl: function getClearAllFacetsUrl() {
      return this.translator.cloneWithoutFacets().getUrl();
    },

    getChildViews: function getChildViews() {
      var childViews = {
        "CCAProductGallery.SchemaPublisher": function () {
          return new SchemaPublisherView({
            schemaPublisherDomId: SCHEMA_PUBLISHER_DOM_ID,
          });
        },
        "CCAProductGallery.Header": function () {
          return new CCAProductGalleryHeaderView({
            pageHeading: this.getPageHeading(),
            textSearchEnabled: this.textSearchEnabled,
            getTranslator: function () {
              return this.translator;
            }.bind(this),
          });
        }.bind(this),
        "CCAProductGallery.VehicleFacets": function () {
          return createFacetedNavigationView({
            facets: this.vehicleFilterModel.getSidebarFacets(
              this.collection.vehicleOptions || [],
              this.translator
            ),
            hasItems: this.collection.length,
            totalProducts: this.collection.totalRecordsFound || 0,
            translator: this.translator,
          });
        }.bind(this),
        "CCAProductGallery.SpecFacets": function () {
          return createFacetedNavigationView({
            facets: getSidebarFacets(this.collection.facets),
            hasItems: this.collection.length,
            totalProducts: this.collection.totalRecordsFound || 0,
            translator: this.translator,
          });
        }.bind(this),
        "Facets.FacetsDisplay": function () {
          return new FacetsFacetsDisplayView({
            facets: getDisplayFacets(this.translator),
            translator: this.translator,
          });
        }.bind(this),
        "GlobalViews.Pagination": function () {
          var view = this;

          return new GlobalViewsPaginationView(
            _.extend(
              {
                currentPage: getCurrentGalleryPage(view),
                totalPages: this.getTotalPages(),
                pager: function (page) {
                  return view.getPaginationUrl(page);
                },
              },
              Configuration.defaultPaginationSettings
            )
          );
        }.bind(this),
        "CCAProductGallery.MobileFacetActionButtons": function () {
          return createMobileFacetActionButtonsView(this);
        }.bind(this),
      };

      return childViews;
    },

    getTotalPages: function getTotalPages() {
      if (
        !this.collection.totalRecordsFound ||
        !this.collection.recordsPerPage
      ) {
        return 0;
      }

      return Math.ceil(
        this.collection.totalRecordsFound / this.collection.recordsPerPage
      );
    },

    getContext: function getContext() {
      var currentPage = this.collection.currentPage || this.currentPage;
      var totalPages = this.getTotalPages();
      var totalRecordsFound = this.collection.totalRecordsFound || 0;
      var recordsPerPage = this.collection.recordsPerPage || this.pageSize;
      var rangeStart = totalRecordsFound
        ? (currentPage - 1) * recordsPerPage + 1
        : 0;
      var rangeEnd = Math.min(currentPage * recordsPerPage, totalRecordsFound);
      var cases = this.getGalleryCases();
      var schema = getGalleryStructuredData(this, cases);

      return {
        hasCases: this.collection.length > 0,
        hasAppliedFacets: !!this.translator.getAllFacets().length,
        hasFacetNavigation:
          !!(this.collection.facets && this.collection.facets.length) ||
          !!(
            this.collection.vehicleOptions &&
            this.collection.vehicleOptions.length
          ) ||
          !!this.translator.getAllFacets().length,
        cases: cases,
        currentPage: currentPage,
        totalPages: totalPages,
        totalRecordsFound: totalRecordsFound,
        resultRangeLabel:
          rangeStart +
          " - " +
          rangeEnd +
          " of " +
          totalRecordsFound +
          " results",
        showPagination: !!(
          this.collection.totalRecordsFound && this.collection.recordsPerPage
        ),
        clearAllFacetsUrl: this.getClearAllFacetsUrl(),
        schemaCollectionPageId: schema.collectionPageId,
        schemaImageGalleryId: schema.imageGalleryId,
        schemaPageUrl: schema.canonicalUrl,
        schemaPageName: schema.name,
        schemaPageDescription: schema.description,
        schemaPageLanguage: schema.language,
        schemaPublisherDomId: SCHEMA_PUBLISHER_DOM_ID,
      };
    },
  });
});
